var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBidLandscape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.88281 18.2285C2.33281 18.2285 1.86198 18.0327 1.47031 17.641C1.07865 17.2493 0.882812 16.7785 0.882812 16.2285V2.22852C0.882812 1.67852 1.07865 1.20768 1.47031 0.816016C1.86198 0.424349 2.33281 0.228516 2.88281 0.228516H16.8828C17.4328 0.228516 17.9036 0.424349 18.2953 0.816016C18.687 1.20768 18.8828 1.67852 18.8828 2.22852V16.2285C18.8828 16.7785 18.687 17.2493 18.2953 17.641C17.9036 18.0327 17.4328 18.2285 16.8828 18.2285H2.88281ZM16.8828 4.47852L10.8328 11.2785L6.88281 7.32852L2.88281 11.3285V14.1785L6.88281 10.1785L10.9328 14.2285L16.8828 7.47852V4.47852Z",
    fill: "#7A1600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidLandscape);
export default __webpack_public_path__ + "static/media/bid_landscape.3dd534cc7125c31025042f1d6256b9ea.svg";
export { ForwardRef as ReactComponent };